import { ApplicationInsights } from '@microsoft/applicationinsights-web';

type StoragePromiseType = Promise<string | null | undefined>;

type StorageWriteResult = void | Promise<void>;

let setStorageItem: (key: string, value: string) => StorageWriteResult;

let getStorageItem: (key: string) => StoragePromiseType;

let getAppInsightsInstance: () => ApplicationInsights;

const setWriteStorageMethod = (
  _setStorageItem: (key: string, value: string) => StorageWriteResult
) => {
  setStorageItem = _setStorageItem;
};

const setReadStorageMethod = (
  _getStorageItem: (key: string) => StoragePromiseType
) => {
  getStorageItem = _getStorageItem;
};

const setReadAppInsightsMethod = (
  _getAppInsightsInstance: () => ApplicationInsights
) => {
  getAppInsightsInstance = _getAppInsightsInstance;
};

export {
  setStorageItem,
  getStorageItem,
  setReadStorageMethod,
  setWriteStorageMethod,
  setReadAppInsightsMethod,
  getAppInsightsInstance,
  StoragePromiseType,
  StorageWriteResult,
};
